module.exports = "/img/bg-tenant.f4d16e77.jpg";